import type {
  F2fTransactionStatus,
  OnlineTransactionStatus,
} from "@gen/app-query";

import { parseMoney } from "~/utilities/money";

export type StatusOption = Pick<
  NonNullable<F2fTransactionStatus | OnlineTransactionStatus>,
  "label" | "color" | "text_color"
> & {
  code: string;
};

export const mapStatusOptions = (
  statuses?: (F2fTransactionStatus | OnlineTransactionStatus)[],
): StatusOption[] =>
  (statuses ?? [])
    .slice()
    .sort((a, b) => a.order - b.order)
    .map(({ code, label, color, text_color }) => ({
      code: String(code),
      label,
      color,
      text_color,
    }));

export const parsePriceFilter = (
  value: string,
  currency: string,
  locale: string,
): number => {
  return parseMoney(value, currency || "USD", locale);
};

export const formatPriceRangeForChip = (
  from: string | undefined,
  to: string | undefined,
): string | undefined => {
  const hasFrom = from !== undefined && from !== "";
  const hasTo = to !== undefined && to !== "";
  if (hasFrom && hasTo) {
    return `${from} – ${to}`;
  }
  if (hasFrom) {
    return `≥ ${from}`;
  }
  if (hasTo) {
    return `≤ ${to}`;
  }
  return undefined;
};

export const formatDateRangeForChip = (
  from: string | undefined,
  to: string | undefined,
  formatter: (iso?: string) => string | undefined,
): string | undefined => {
  const fromText = formatter(from);
  const toText = formatter(to);
  if (fromText && toText) {
    return `${fromText} – ${toText}`;
  }
  if (fromText) {
    return `≥ ${fromText}`;
  }
  if (toText) {
    return `≤ ${toText}`;
  }
  return undefined;
};
